<template>
  <div class="checkout">
    <loading-panel :loading="isLoadingOrder" message="Loading your order">
      <div v-if="errors.length == 0">
        <h3 class="m-0">In Your Cart:</h3>
        <div
          v-for="type in $consts.purchaseableNodeTypes"
          :key="`type-count-${type}`"
          :set="count = typeCountMap[$consts.NODE_TYPE_STR_TO_INT[type]]"
        >
          <div v-if="count">{{ count }} {{ $consts.NODE_LABELS_FOR_PATH_TYPE[type] }}</div>
        </div>
        <hr />

        <h2>Order Options</h2>
        <div
          class="mb-3"
        >Use the selections below to let us know some more details about how you wish to receive your order.</div>
      </div>

      <div v-for="option in checkoutOptions" :key="option.label" class="option-group">
        <div v-if="option.type == 1">
          <input :id="option.label" type="checkbox" v-model="optionSelections[option.id]" />
          <label :for="option.label">&nbsp;{{option.label}}</label>
        </div>
        <div v-if="option.type == 2">
          <label>{{option.label}}</label>
          <div>
            <textarea v-model="optionSelections[option.id]" />
          </div>
        </div>
      </div>

      <div class="text-right">
        <loading-panel :loading="isLoading" message="Preparing your order">
          <button class="btn" @click="onNext">Next: Payment Details</button>
        </loading-panel>
      </div>
      <error-panel class="text-center" :errors="errors"></error-panel>
    </loading-panel>

    <error-panel :errors="[error]"></error-panel>
    <hr />
  </div>
</template>

<script>
export default {
  name: "checkout",
  components: {},
  data() {
    return {
      error: "",
      isLoadingOrder: false,
      isLoading: false,
      errors: [],
      checkoutOptions: [],
      optionSelections: [],
      nodeIds: [],
      typeCountMap: {}
    };
  },
  methods: {
    async onNext() {
      // Create the order in PV database
      try {
        this.isLoading = true;

        const response = await this.$web.createMobileOrder(
          this.nodeIds,
          this.optionSelections,
          window.location.origin,
          this.$route.params.uuid,
        );

        if (!response.data.sessionId) {
          this.error = "Unable to create checkout session at this time";
          return;
        }

        const stripe = Stripe(process.env.VUE_APP_STRIPE_PK);
        await stripe.redirectToCheckout({
          sessionId: response.data.sessionId
        });
      } catch (e) {
        console.log("Error: ", e);
        this.error = "An error occurred. Unable to place order at this time.";
      } finally {
        this.isLoading = false;
      }
    }
  },
  computed: {},
  async mounted() {
    try {
      this.isLoadingOrder = true;

      const uuid = this.$route.params.uuid;
      if (!uuid) {
        this.errors = ["Unable to load data for this mobile order."];
        return;
      }

      const result = await this.$web.getMobileOrder(uuid);

      this.checkoutOptions = result.data.checkoutOptions;
      this.nodeIds = JSON.parse(result.data.mobileOrder.ids);
      this.typeCountMap = JSON.parse(result.data.mobileOrder.types);
    } catch (e) {
      this.errors = ["Unable to load data for this mobile order."];
    } finally {
      this.isLoadingOrder = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/custom.scss";

.checkout {
  font-family: Roboto, Arial, Helvetica, sans-serif, "Segoe UI Emoji",
    "Segoe UI Symbol";
  background: white;
  padding: 5px;
  margin: auto;
  margin-top: 15px;
  max-width: 360px;

  @media screen and (min-width: 768px + 250px + 50px) {
    max-width: 768px;
  }
}

.option-group {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
